// Product Card Image Swipe - Claire Hill Designs (v3 - Mobile Only - Missoma Style Dots)
(function() {
  'use strict';
  
  console.log('Product card swipe script loaded');
  
  class ProductCardSwipe {
    constructor(card) {
      this.card = card;
      this.images = [];
      this.currentIndex = 0;
      this.startX = 0;
      this.isDragging = false;
      
      this.init();
    }
    
    init() {
      // Only run on touch devices
      if (!('ontouchstart' in window)) {
        console.log('Not a touch device, skipping');
        return;
      }
      
      console.log('Initializing card swipe');
      
      // Find the image element - try multiple selectors
      this.imageElement = this.card.querySelector('img[src*="products"]') || 
                          this.card.querySelector('.card__media img') ||
                          this.card.querySelector('.media img') ||
                          this.card.querySelector('img');
      
      if (!this.imageElement) {
        console.log('No image found in card');
        return;
      }
      
      // Get product handle from URL
      const productLink = this.card.querySelector('a[href*="/products/"]');
      if (!productLink) {
        console.log('No product link found');
        return;
      }
      
      const productHandle = productLink.href.split('/products/')[1].split('?')[0];
      console.log('Product handle:', productHandle);
      
      // Fetch product data
      this.fetchProductImages(productHandle);
      
      // Add touch listeners
      this.card.addEventListener('touchstart', this.handleTouchStart.bind(this), { passive: true });
      this.card.addEventListener('touchmove', this.handleTouchMove.bind(this), { passive: false });
      this.card.addEventListener('touchend', this.handleTouchEnd.bind(this));
    }
    
    async fetchProductImages(handle) {
      try {
        const response = await fetch(`/products/${handle}.json`);
        const data = await response.json();
        
        if (data.product && data.product.images && data.product.images.length > 1) {
          this.images = data.product.images;
          this.createDots();
          
          // Preload the next image for faster swipes
          if (this.images[1]) {
            const preloadImg = new Image();
            preloadImg.src = this.images[1].src;
          }
        }
      } catch (error) {
        console.error('Error fetching product:', error);
      }
    }
    
    createDots() {
      const dotsContainer = document.createElement('div');
      dotsContainer.className = 'product-card-dots';
      dotsContainer.style.cssText = 'position:absolute;bottom:8px;left:50%;transform:translateX(-50%);display:flex;gap:4px;z-index:10;';
      
      this.images.forEach((_, index) => {
        const dot = document.createElement('span');
        dot.className = 'product-card-dot';
        // Inactive dots: white with opacity, Active dots: navy
        if (index === 0) {
          dot.style.cssText = 'width:5px;height:5px;border-radius:50%;background:#1a3a52;transition:all 0.3s;';
        } else {
          dot.style.cssText = 'width:5px;height:5px;border-radius:50%;background:rgba(255,255,255,0.5);transition:all 0.3s;';
        }
        dotsContainer.appendChild(dot);
      });
      
      // Find media container
      let mediaContainer = this.imageElement.closest('.card__media') || 
                          this.imageElement.closest('.media') ||
                          this.imageElement.parentElement;
      
      if (mediaContainer) {
        mediaContainer.style.position = 'relative';
        mediaContainer.appendChild(dotsContainer);
        console.log('Dots added');
      }
      
      this.dotsContainer = dotsContainer;
    }
    
    handleTouchStart(e) {
      if (this.images.length <= 1) return;
      this.startX = e.touches[0].clientX;
      this.isDragging = true;
    }
    
    handleTouchMove(e) {
      if (!this.isDragging || this.images.length <= 1) return;
      
      const currentX = e.touches[0].clientX;
      const diff = Math.abs(this.startX - currentX);
      
      if (diff > 10) {
        e.preventDefault();
      }
    }
    
    handleTouchEnd(e) {
      if (!this.isDragging || this.images.length <= 1) return;
      
      const endX = e.changedTouches[0].clientX;
      const diff = this.startX - endX;
      
      if (Math.abs(diff) > 50) {
        if (diff > 0) {
          this.nextImage();
        } else {
          this.prevImage();
        }
      }
      
      this.isDragging = false;
    }
    
    nextImage() {
      this.currentIndex = (this.currentIndex + 1) % this.images.length;
      this.updateImage();
    }
    
    prevImage() {
      this.currentIndex = (this.currentIndex - 1 + this.images.length) % this.images.length;
      this.updateImage();
    }
    
    updateImage() {
      const image = this.images[this.currentIndex];
      let newSrc = image.src;
      
      // Don't modify the URL - use it as-is from Shopify
      this.imageElement.src = newSrc;
      
      // Also update srcset if it exists
      if (this.imageElement.hasAttribute('srcset')) {
        this.imageElement.srcset = newSrc;
      }
      
      // Preload next image for smoother experience
      const nextIndex = (this.currentIndex + 1) % this.images.length;
      if (this.images[nextIndex]) {
        const preloadImg = new Image();
        preloadImg.src = this.images[nextIndex].src;
      }
      
      // Update dots
      if (this.dotsContainer) {
        const dots = this.dotsContainer.querySelectorAll('.product-card-dot');
        dots.forEach((dot, index) => {
          if (index === this.currentIndex) {
            dot.style.background = '#1a3a52'; // Navy for active
          } else {
            dot.style.background = 'rgba(255,255,255,0.5)'; // White with opacity for inactive
          }
        });
      }
    }
  }
  
  // Initialize
  function initSwipe() {
    console.log('Initializing product card swipe');
    
    // Try multiple selectors for product cards
    const selectors = [
      '.card-wrapper',
      '.product-card-wrapper',
      '.grid__item',
      '.product-grid-item',
      '.collection .card',
      'li.grid__item'
    ];
    
    let cards = [];
    selectors.forEach(selector => {
      const found = document.querySelectorAll(selector);
      if (found.length > 0) {
        console.log('Found', found.length, 'cards with selector:', selector);
        cards = [...cards, ...Array.from(found)];
      }
    });
    
    // Remove duplicates
    cards = [...new Set(cards)];
    
    console.log('Total unique cards:', cards.length);
    cards.forEach(card => new ProductCardSwipe(card));
  }
  
  // Run on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSwipe);
  } else {
    initSwipe();
  }
  
  // Also run after a short delay in case content loads dynamically
  setTimeout(initSwipe, 1000);
  
})();
